import styled from "styled-components";
import {colors} from "../../res/values/values"
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as userActions from "../../redux/actions/userActions";
import useForm from "../../utilities/hooks/useForm";
import {loginValidateInfo} from '../../utilities/helpers';
import { useNavigate } from "react-router-dom";
//#region STYLES

const Container = styled.div`
  min-height: 40vw; 
  display: flex;
  flex-direction: column;
 
  padding-top: 20px;
`;
const Wrapper = styled.div`
  padding: 20px;
  background-color: white;
`;
const Title = styled.div`
  font-size: 24px;
  font-weight: 300;
`;
const Error = styled.div`
  padding: 5px;
  color: #a94442;
  background-color: #f2dede;
  border-color: #ebccd1;
  font-size: 16px;
  font-weight: 300;
`;
const Form = styled.form`
  display: flex;
  flex-direction: column;
`;
const Input = styled.input`
  flex: 1;
  min-width: 40%;
  margin: 10px 0;
  padding: 10px;  
  border: 1px;
  border-color: lightgray;
  border-style: solid;
  &:focus  {
    outline: none !important;
    border-color: ${colors.secondryColor};
  }
`;
const Button = styled.input`
  border-width: 1px;
  border-style: solid;
  border-radius: 1px;
  border-color:${colors.darkcolor} ;
  font-weight: 500;
  padding: 15px 20px;
  background-color: ${colors.primaryColor};
  color: ${colors.blackColor};
  margin-bottom: 10px;
  cursor: pointer;
  &:hover{
    background-color: ${colors.blackColor};
    color: ${colors.primaryColor};
  }
`;
const Link = styled.a`
  margin: 5px 0;
  font-size: 12px;
  text-decoration: underline;
  cursor: pointer;
`;
//#endregion

function Login(props) {
  const navigate = useNavigate()
  const userLoginFunc = async (values) => {    
    let user={
      "email":values.email,
      "password":values.password
    }
    if(await props.actions.loginUser(user)){
      try {
        props.goBack()
        return true
      } catch (error) {
        navigate("/");
        return true
      }
    }else 
      return false
   
  };

  const { handleChange, handleSubmit, values, errors } = useForm(
    userLoginFunc,
    loginValidateInfo
  );
  return (
    <Container>
      {(props.loginError!=="") ? <Error>{props.loginError}</Error> : <div></div>}
      <Wrapper>
        
        <Title>SIGN IN</Title>
        <Form onSubmit={handleSubmit}>
          <Input name="email" onChange={handleChange} type="text" placeholder="email" value={values.email}/>
          {errors.email && <p style={{color:'red'}}>{errors.email}</p>}
          <Input name="password" onChange={handleChange} type="password" placeholder="password" value={values.password} autocomplete="current-password"/>
          {errors.password && <p style={{color:'red'}}>{errors.password}</p>}
          <Button type="submit" value="Login"></Button>
          <Link onClick={(_) => navigate("/route=account/forgotPassword")}>FORGOT PASSWORD?</Link>
          <Link onClick={(_) => navigate("/route=account/register")}>CREATE A NEW ACCOUNT</Link>
        </Form>
      </Wrapper>
    </Container>
  );
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      loginUser : bindActionCreators(userActions.loginUser,dispatch),
    },
  };
}
function mapStateToProps(state) {
  return {
    loginError: state.currentUserErrorReducer,
  };
}
export default connect(mapStateToProps,mapDispatchToProps)(Login) ;
